
{
  "familyId": "GET-WETENSCHAP-REKEN",
  "questions": [
    {
      "id": "GET-WETENSCHAP-REKEN-001",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Wat is 3 × 10⁴ + 2 × 10⁴?",
      "options": [
        "5 × 10⁴",
        "5 × 10⁸",
        "6 × 10⁴",
        "5 × 10⁴⁺⁴"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wetenschap_optellen",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: bij dezelfde macht van 10 tel je de coëfficiënten op. Stap 1: Zelfde macht: 10⁴. Stap 2: Coëfficiënten: 3 + 2 = 5. Stap 3: Antwoord: 5 × 10⁴.",
        "distractorExplanations": {
          "0": "Goed! 3 × 10⁴ + 2 × 10⁴ = (3 + 2) × 10⁴ = 5 × 10⁴.",
          "1": "Veelgemaakte fout: de exponenten optellen. Bij optellen blijft de exponent gelijk. 10⁴ + 10⁴ ≠ 10⁸.",
          "2": "Veelgemaakte fout: de coëfficiënten vermenigvuldigen. 3 + 2 = 5, niet 3 × 2 = 6.",
          "3": "Veelgemaakte fout: de exponenten optellen in de notatie. Bij optellen verandert de exponent niet."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-002",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Wat is (2 × 10³) × (4 × 10²)?",
      "options": [
        "8 × 10⁵",
        "8 × 10⁶",
        "6 × 10⁵",
        "8 × 10⁵⁺²"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wetenschap_vermenigvuldigen",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig coëfficiënten en tel exponenten op. Stap 1: Coëfficiënten: 2 × 4 = 8. Stap 2: Exponenten: 10³ × 10² = 10³⁺² = 10⁵. Stap 3: Antwoord: 8 × 10⁵.",
        "distractorExplanations": {
          "0": "Goed! (2 × 4) × 10³⁺² = 8 × 10⁵.",
          "1": "Veelgemaakte fout: de exponenten vermenigvuldigen. 10³ × 10² = 10⁵ (optellen), niet 10⁶.",
          "2": "Veelgemaakte fout: de coëfficiënten optellen. 2 × 4 = 8 (vermenigvuldigen), niet 2 + 4 = 6.",
          "3": "Veelgemaakte fout: de exponenten niet correct noteren. 10³⁺² = 10⁵."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-003",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Wat is (9 × 10⁶) ÷ (3 × 10²)?",
      "options": [
        "3 × 10⁴",
        "3 × 10³",
        "6 × 10⁴",
        "3 × 10⁸"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wetenschap_delen",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: deel coëfficiënten en trek exponenten af. Stap 1: Coëfficiënten: 9 ÷ 3 = 3. Stap 2: Exponenten: 10⁶ ÷ 10² = 10⁶⁻² = 10⁴. Stap 3: Antwoord: 3 × 10⁴.",
        "distractorExplanations": {
          "0": "Goed! (9 ÷ 3) × 10⁶⁻² = 3 × 10⁴.",
          "1": "Veelgemaakte fout: de exponenten delen. 10⁶ ÷ 10² = 10⁴ (aftrekken), niet 10³.",
          "2": "Veelgemaakte fout: de coëfficiënten aftrekken. 9 ÷ 3 = 3 (delen), niet 9 − 3 = 6.",
          "3": "Veelgemaakte fout: de exponenten optellen. Bij delen trek je af: 6 − 2 = 4, niet 6 + 2 = 8."
        }
      }
    },
    {
      "id": "GET-WETENSCHAP-REKEN-004",
      "familyId": "GET-WETENSCHAP-REKEN",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "wetenschappelijk",
      "subSkill": "wetenschap_rekenen",
      "questionType": "multiple_choice",
      "question": "Schrijf het antwoord in wetenschappelijke notatie: (5 × 10³) × (6 × 10²)",
      "options": [
        "3 × 10⁶",
        "30 × 10⁵",
        "3 × 10⁵",
        "30 × 10⁶"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wetenschap_normaliseren",
      "variantIndex": 4,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig en normaliseer. Stap 1: 5 × 6 = 30 en 10³ × 10² = 10⁵. Stap 2: 30 × 10⁵. Stap 3: Normaliseer: 30 = 3 × 10¹. Stap 4: 3 × 10¹ × 10⁵ = 3 × 10⁶.",
        "distractorExplanations": {
          "0": "Goed! 30 × 10⁵ = 3 × 10⁶ (genormaliseerd).",
          "1": "Bijna goed! 30 × 10⁵ is wiskundig correct maar niet in wetenschappelijke notatie. Normaliseer: 3 × 10⁶.",
          "2": "Veelgemaakte fout: niet normaliseren. 5 × 6 = 30, niet 3. En 30 × 10⁵ = 3 × 10⁶.",
          "3": "Veelgemaakte fout: dubbel tellen. 30 × 10⁵ = 3 × 10⁶, niet 30 × 10⁶."
        }
      }
    }
  ]
}
